import Typography from "@material-ui/core/Typography";
import {Grid} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import addressData from "../../data/addressData.json";
import {isTokenValid} from "../../utils/sessionUtils";

export default function OtherDetailsViewTile({consumerData,handleBooleans}) {
    const [disToCoastList, setDisToCoastList] = useState([]);
    const [showFireStation, setShowFireStation] = useState(false);
    const [showDistanceToCoast, setShowDistanceToCoast] = useState(false);

    useEffect(() => {
        setDisToCoastList(addressData.distanceToCoast)
        setShowFireStation(consumerData?.fireStationPrefill !== 'N' || isTokenValid());
        setShowDistanceToCoast(consumerData?.distanceToCoastPrefill !== 'N' || isTokenValid())
    }, []);

    return (
        <>
            <Typography variant="h5" component="h2">
                Other Details
            </Typography>
            <Grid container spacing={{xs: 2, md: 3}} columns={{xs: 4, sm: 8, md: 12}}>
                <Grid item xs={12} sm={6} md={4}>
                    Number of property claims you have filed in the last three years<br/>
                    <b>{consumerData?.numOfClaims}</b>
                </Grid>
                {consumerData?.numOfClaims > 0 &&
                <>
                    <Grid item xs={12} sm={6} md={4}>
                        Claim Type Description<br/>
                        <b>{consumerData?.lossType}</b>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        Claim Status<br/>
                        <b>{consumerData?.claimStatus}</b>
                    </Grid>
                </>
                }
                {showDistanceToCoast && <Grid item xs={12} sm={6} md={4}>
                    What is the property’s distance to salt water? (e.g., ocean intercoastal)<br/>
                    <b>{disToCoastList.filter(i => i.value === consumerData?.milesFromSaltWater)[0]?.label}</b>
                </Grid>}
                <Grid item xs={12} sm={6} md={4}>
                    Do you have a pool?<br/>
                    <b>{handleBooleans(consumerData?.hasOnsitePool)}</b>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    Is the property located within 1000 ft. of a fire hydrant?<br/>
                    <b>{handleBooleans(consumerData?.isLocated1000ftFireHydrant)}</b>
                </Grid>
                {showFireStation && <Grid item xs={12} sm={6} md={4}>
                    Is the property located within five miles of a manned fire station?<br/>
                    <b>{handleBooleans(consumerData?.is5miFromMannedFireStation)}</b>
                </Grid>}
            </Grid>
        </>
    );
}
